import { coreStakeholdersIdMapSlice } from './update';

export const coreStakeholdersIdMapReducers = coreStakeholdersIdMapSlice.syncReducer;
